var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 80,
    viewBox: "0 0 79 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7921 73.1046H3.67381C2.28359 73.1046 1.15723 71.964 1.15723 70.5562V9.4437C1.15723 8.03589 2.28359 6.89526 3.67381 6.89526H75.3262C76.7164 6.89526 77.8428 8.03589 77.8428 9.4437V70.5562C77.8428 71.964 76.7164 73.1046 75.3262 73.1046H62.1924",
    stroke: "#B82428",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91865 16.8406H1.5752",
    stroke: "#B82428",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4247 16.8406H11.3193",
    stroke: "#B82428",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1738 38.2332L8.71799 29.7308C8.49966 28.4555 9.34351 27.2423 10.603 27.0212C11.863 26.8001 13.0605 27.6546 13.2788 28.9301L14.8601 38.1651",
    stroke: "#B82428",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3037 37.9863L32.8544 28.9301C33.0727 27.6547 34.2701 26.8001 35.5302 27.0212C36.7897 27.2422 37.6336 28.4555 37.4153 29.7308L35.9943 38.0293",
    stroke: "#B82428",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7399 58.3188V60.9209C34.7399 61.6701 34.1401 62.2776 33.4001 62.2776H12.7323C11.9925 62.2776 11.3926 61.6703 11.3926 60.9209V58.3188",
    stroke: "#B82428",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1053 57.9813H35.0058C35.8189 57.9813 36.5148 57.3892 36.6552 56.5767L39.5915 39.4282C39.6794 38.9095 39.2859 38.436 38.766 38.436H7.3681C6.84812 38.436 6.45466 38.9095 6.54261 39.4282L9.47888 56.5767C9.61775 57.3892 10.3136 57.9813 11.1283 57.9813H14.7049",
    stroke: "#B82428",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0664 44.1018V52.3157",
    stroke: "#B82428",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3691 44.1018L16.7078 52.3157",
    stroke: "#B82428",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7635 44.1018L29.4248 52.3157",
    stroke: "#B82428",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6904 39.4089H65.2007",
    stroke: "#B82428",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1951 25.0657H72.0752V33.1063H45.6904V25.0657H59.7947",
    stroke: "#B82428",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6904 45.7122H62.1922",
    stroke: "#B82428",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6904 52.0156H65.2007",
    stroke: "#B82428",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6904 58.3188H62.1922",
    stroke: "#B82428",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4648 39.4089H72.0754",
    stroke: "#B82428",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4648 45.7122H72.0754",
    stroke: "#B82428",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4648 52.0156H72.0754",
    stroke: "#B82428",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4648 58.3188H72.0754",
    stroke: "#B82428",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4482 64.6221H72.0758",
    stroke: "#B82428",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineStore);
export default __webpack_public_path__ + "static/media/onlineStore.6c1d308564704d033c9d05105396163b.svg";
export { ForwardRef as ReactComponent };